import React from "react";
import { component_tool, utils_tool } from '@/tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;


//配置项
let componentName = 'tableConfig'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "数据库表名",
    name: "tableName",
    dataIndex: "tableName",
    searchItem: {},
    formItem: {
      maxlength: 64,
      placeholder: '数据库表名不能超过64个字符',
      rules: [
        {
          required: true,
          message: '请输入数据库表名'
        }
      ],
    },
    tableItem: {}
  },
  {
    title: "中文表名",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    formItem: {
      maxlength: 64,
      placeholder: '中文表名不能超过64个字符',
      rules: [
        {
          required: true,
          message: '请输入中文表名'
        }
      ],
    },
    tableItem: {}
  },
  {
    title: "数据源",
    name: "dataSource",
    dataIndex: "dataSource",
    tableItem: {},
    dict: [
      { code: 0, codeName: "lms_base" },
      { code: 1, codeName: "lms_base_biz" },
      { code: 2, codeName: "lms_common" },
      { code: 3, codeName: "lms_content_application" },
      { code: 4, codeName: "lms_data_center" },
      { code: 5, codeName: "lms_face" },
      { code: 6, codeName: "lms_internal_train" },
      { code: 7, codeName: "lms_message_center" },
      { code: 8, codeName: "lms_online_interact" },
      { code: 9, codeName: "lms_open_api" },
      { code: 10, codeName: "lms_other" },
      { code: 11, codeName: "lms_rules_center" },
      { code: 12, codeName: "lms_train_help" },
      { code: 13, codeName: "lms_workflow" }
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: 'select',
      rules: [{
        required: true,
        message: '请选择数据源',
      }]
    }
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 0, codeName: "无效" },
      { code: 1, codeName: "有效" }
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: 'select',
      rules: [{
        required: true,
        message: '请选择状态',
      }],
      initialValue: 1
    }
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        collapse:false,
        cols: {
          xs: 12,
          md: 12,
          xl: 12
        },
        buttonSort: ['add'],
        buttons: [
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
      },
      rowOperateSort: ['update','enableOrDisable','look'],
      rowOperateView: [
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "启用"},
          textFormat: {
            recordKey: 'state',
            dirt: { 1: '禁用', 0: "启用" }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateTableConfigState",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['state'] === 0 ? "启用" : "禁用"
              }该表吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 1 ? 0 : 1,
                    id: record['id']
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: 'look',//课程查看
          custom: true,
          params: { children: '详情'},
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
              pathname: '/dataReport/tableConfig/tableField'
            }
          }
        }
      ],
      commonOperate: {
      },
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  updateTableConfigState: {
    path: `${componentName}/updateTableConfigState`,
    payload: {
      key: `${componentName}@updateTableConfigState`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
